import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";

const STORAGE_KEY = "sac_cookie_consent";

function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
      className="fixed bottom-0 inset-x-0 z-[1000] p-4 sm:p-6"
    >
      <div className="max-w-4xl mx-auto bg-[#071A2F] border border-white/10 text-white rounded-2xl shadow-2xl p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex-1">
          <p id="cookie-consent-title" className="font-semibold text-base">
            Cookie &amp; Privacy Notice
          </p>
          <p id="cookie-consent-desc" className="mt-1 text-sm text-slate-300 leading-relaxed">
            We use essential cookies and analytics to improve your experience. By continuing,
            you agree to our{" "}
            <Link to={ROUTES.COOKIE_POLICY} className="text-red-400 hover:underline">
              Cookie Policy
            </Link>{" "}
            and{" "}
            <Link to={ROUTES.PRIVACY_POLICY} className="text-red-400 hover:underline">
              Privacy Policy
            </Link>
            .
          </p>
        </div>
        <button
          type="button"
          onClick={accept}
          className="group relative shrink-0 overflow-hidden rounded-full bg-red-600 px-6 py-3 text-sm font-semibold transition-all duration-300 hover:-translate-y-1 hover:scale-[1.03] hover:bg-red-700"
        >
          <span className="relative z-10">Accept</span>
          <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-all duration-700 group-hover:translate-x-full" />
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
